import { call, put } from 'redux-saga/effects';
import api from '../../services/api';

import { Creators as FaqCreators } from '../ducks/faq';

export function* getFaq() {
  const response = yield call(api.get, 'v1/sites/faq');
  if (response.ok) {
    yield put(FaqCreators.getFaqSuccess(response.data.faq));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/faq.js